import React from "react";
import { Radio } from "antd";
import "./radio-button.css";

export default class RadioButtonComponent extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
        value: this.props.value,
        disabled: this.props.disabled,
        textos: this.props.textos
    };
}

  onChange = (e) => {
    this.setState({
      value: e.target.value
    });
    this.props.onChange(e)
  };

  render() {
    return (
      <Radio.Group
        className="radio-button"
        disabled={this.state.disabled}
        onChange={this.onChange}
        value={this.state.value}
      >
      <Radio value={0}>{this.state.textos.BODY.RADIO.OPCIONES.SOLICITUD}</Radio>
      <Radio value={1}>{this.state.textos.BODY.RADIO.OPCIONES.RUT}</Radio>
      </Radio.Group>
    );
  }
}